<template>
    <div class="bar-container">
            <div id="myBarCharts" style="height:380px;width:100%"></div>
    </div>
</template>
<script>
import {statisticsAPI } from 'liankong-ui-api'
import * as echarts from 'echarts'
export default {
    data(){
        return {
            
        }
    },
    mounted(){
    },
    methods:{
        getTop10(startDay,endDay){
            statisticsAPI.statisTop10({
            endDay,
            startDay
        }).then(res=>{
            if(res.code==0){
                let mCharts = echarts.init(document.getElementById('myBarCharts'))
                let salvProName =res.data.map(item=>item.toolName);
                let  salvProValue =res.data.map(item=>item.useCount);
                let salvProMax =[];//背景按最大值
                for (let i = 0; i < salvProValue.length; i++) {
                    salvProMax.push(salvProValue[0])
                }
                const option = {
                    title: {					         	
                                text:'文档工具使用次数TOP10',
                                x:"1%",
                                y:'5%',
                                textStyle:{
                                    fontSize:15,
                                    color:'#06f1ef'
                                }
                            },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '2%',
                        top: '14%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none'
                        },
                        formatter: function(params) {
                            return params[0].name  + ' : ' + params[0].value + '次';
                        }
                    },
                    xAxis: {
                        show: false,
                        type: 'value'
                    },
                    yAxis: [{
                        type: 'category',
                        inverse: true,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            },
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName
                    }, {
                        type: 'category',
                        inverse: true,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',
                                fontSize: '12'
                            },
                        },
                        data:salvProValue
                    }],
                    series: [{
                            name: '值',
                            type: 'bar',
                            zlevel: 1,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 30,
                                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                        offset: 0,
                                        color: 'rgb(57,89,255,1)'
                                    }, {
                                        offset: 1,
                                        color: 'rgb(46,200,207,1)'
                                    }]),
                                },
                            },
                            barWidth: 20,
                            data: salvProValue
                        },
                        {
                            name: '背景',
                            type: 'bar',
                            barWidth: 20,
                            barGap: '-100%',
                            data: salvProMax,
                            itemStyle: {
                                normal: {
                                    color: 'rgba(24,31,68,1)',
                                    barBorderRadius: 30,
                                }
                            },
                        },
                    ]
                };
                mCharts.setOption(option)
            } else {
                this.$message.error(res.message)
            }
        })
        }
    }
}
</script>

<style lang="less" scoped>
.bar-container{
	position: relative;
	.searchBox{
		position: absolute;
		right: 20px;
		top: 25px;
		color: rgba(255, 255, 255, 0.4);
		span{
			margin-right: 10px;
			border: 1px solid rgba(255, 255, 255, 0.4);
			padding: 3px 5px;
			font-size: 12px;
		}
	}
}
	
</style>